const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoftware(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "983px",
    height: "359px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.973
    },
    fill: "#f4ab25",
    d: "M 169.5,0.5 C 172.833,0.5 176.167,0.5 179.5,0.5C 182.223,8.27831 185.223,15.945 188.5,23.5C 185.097,23.8511 181.763,24.5178 178.5,25.5C 175.215,17.2639 172.215,8.93058 169.5,0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.955
    },
    fill: "#f6b52a",
    d: "M 183.5,-0.5 C 186.5,-0.5 189.5,-0.5 192.5,-0.5C 197.5,0.166667 202.5,0.833333 207.5,1.5C 209.968,8.23441 212.634,14.9011 215.5,21.5C 206.368,21.1198 197.368,21.7865 188.5,23.5C 185.223,15.945 182.223,8.27831 179.5,0.5C 181.099,0.767809 182.432,0.434475 183.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.969
    },
    fill: "#f0a125",
    d: "M 169.5,0.5 C 172.215,8.93058 175.215,17.2639 178.5,25.5C 172.234,27.6345 166.234,30.3012 160.5,33.5C 156.636,23.9063 152.969,14.2397 149.5,4.5C 156.097,2.78064 162.763,1.44731 169.5,0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.96
    },
    fill: "#f7bb39",
    d: "M 207.5,1.5 C 212.894,1.73252 218.227,2.39919 223.5,3.5C 226.833,10.1667 230.167,16.8333 233.5,23.5C 227.511,22.7397 221.511,22.0731 215.5,21.5C 212.634,14.9011 209.968,8.23441 207.5,1.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.952
    },
    fill: "#f8c045",
    d: "M 223.5,3.5 C 230.169,4.7447 236.502,6.7447 242.5,9.5C 245.578,15.9913 248.912,22.3246 252.5,28.5C 246.108,26.9856 239.775,25.3189 233.5,23.5C 230.167,16.8333 226.833,10.1667 223.5,3.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.968
    },
    fill: "#ec9425",
    d: "M 149.5,4.5 C 152.969,14.2397 156.636,23.9063 160.5,33.5C 154.307,36.7623 148.64,40.7623 143.5,45.5C 138.636,33.5738 133.969,21.5738 129.5,9.5C 136.063,7.4234 142.73,5.75674 149.5,4.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.968
    },
    fill: "#ea8c24",
    d: "M 129.5,9.5 C 133.969,21.5738 138.636,33.5738 143.5,45.5C 141.5,48.1667 139.167,50.5 136.5,52.5C 130.385,39.8222 125.052,26.8222 120.5,13.5C 123.428,12.1833 126.428,10.85 129.5,9.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.974
    },
    fill: "#e88624",
    d: "M 120.5,13.5 C 125.052,26.8222 130.385,39.8222 136.5,52.5C 134.397,55.7198 132.064,58.7198 129.5,61.5C 122.912,47.0697 116.912,32.4031 111.5,17.5C 114.256,15.7962 117.256,14.4629 120.5,13.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.934
    },
    fill: "#f8c452",
    d: "M 242.5,9.5 C 250.346,11.4286 257.679,14.4286 264.5,18.5C 269.335,26.1581 274.668,33.4915 280.5,40.5C 271.099,36.4608 261.765,32.4608 252.5,28.5C 248.912,22.3246 245.578,15.9913 242.5,9.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.978
    },
    fill: "#e67f24",
    d: "M 111.5,17.5 C 116.912,32.4031 122.912,47.0697 129.5,61.5C 127.152,65.5355 124.818,69.5355 122.5,73.5C 114.112,57.0598 107.112,40.0598 101.5,22.5C 104.55,20.3084 107.883,18.6417 111.5,17.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.979
    },
    fill: "#e47924",
    d: "M 101.5,22.5 C 107.112,40.0598 114.112,57.0598 122.5,73.5C 121.167,77.5 119.833,81.5 118.5,85.5C 107.951,67.3985 99.284,48.3985 92.5,28.5C 95.2911,26.2651 98.2911,24.2651 101.5,22.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.858
    },
    fill: "#f9c85d",
    d: "M 264.5,18.5 C 290.179,31.5287 311.846,49.5287 329.5,72.5C 328.998,73.521 328.332,73.6877 327.5,73C 312.812,60.6638 297.145,49.8305 280.5,40.5C 274.668,33.4915 269.335,26.1581 264.5,18.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.98
    },
    fill: "#e27324",
    d: "M 92.5,28.5 C 99.284,48.3985 107.951,67.3985 118.5,85.5C 117.148,90.2544 115.814,94.9211 114.5,99.5C 102.615,78.7286 92.6151,57.0619 84.5,34.5C 86.8599,32.1468 89.5265,30.1468 92.5,28.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.98
    },
    fill: "#e06d24",
    d: "M 84.5,34.5 C 92.6151,57.0619 102.615,78.7286 114.5,99.5C 114.663,104.547 114.329,109.547 113.5,114.5C 99.4162,93.6698 87.9162,71.3365 79,47.5C 78.5831,46.244 77.7498,45.5774 76.5,45.5C 77.2341,44.2921 77.5674,42.9587 77.5,41.5C 79.5,38.8333 81.8333,36.5 84.5,34.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.988
    },
    fill: "#de6724",
    d: "M 76.5,45.5 C 77.7498,45.5774 78.5831,46.244 79,47.5C 87.9162,71.3365 99.4162,93.6698 113.5,114.5C 114.269,122.788 115.603,131.122 117.5,139.5C 99.4408,115.397 84.4408,89.3967 72.5,61.5C 72.8968,55.9129 74.2301,50.5795 76.5,45.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6b125",
    d: "M 77.5,41.5 C 77.5674,42.9587 77.2341,44.2921 76.5,45.5C 74.2301,50.5795 72.8968,55.9129 72.5,61.5C 71.3483,66.9846 71.1816,72.6513 72,78.5C 73.2568,87.098 75.4235,95.4314 78.5,103.5C 77.2193,130.965 69.886,156.632 56.5,180.5C 54.4214,180.029 52.4214,179.363 50.5,178.5C 50.3893,177.883 50.056,177.383 49.5,177C 69.9005,139.467 75.5671,99.8001 66.5,58C 69.133,53.0465 72.133,48.3798 75.5,44C 75.2716,43.6012 74.9382,43.4346 74.5,43.5C 75.2905,42.5987 76.2905,41.9321 77.5,41.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#f8c451",
    d: "M 60.5,50.5 C 62.4974,52.513 64.164,54.8463 65.5,57.5C 63.0478,60.606 61.0478,63.9393 59.5,67.5C 57.5,70.1667 55.5,72.8333 53.5,75.5C 51.0269,71.2295 48.5269,66.8961 46,62.5C 44.9887,61.6634 43.8221,61.33 42.5,61.5C 47.9673,57.0474 53.9673,53.3808 60.5,50.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.985
    },
    fill: "#dc6024",
    d: "M 72.5,61.5 C 84.4408,89.3967 99.4408,115.397 117.5,139.5C 121.104,150.038 125.77,160.038 131.5,169.5C 130.5,168.833 129.5,168.167 128.5,167.5C 127.167,165.5 125.5,163.833 123.5,162.5C 119.472,158.141 115.472,153.807 111.5,149.5C 108.138,145.808 104.805,142.141 101.5,138.5C 99.8532,135.527 97.8532,132.86 95.5,130.5C 93.8532,127.527 91.8532,124.86 89.5,122.5C 88.3197,119.46 86.653,116.794 84.5,114.5C 82.7505,110.665 80.7505,106.999 78.5,103.5C 75.4235,95.4314 73.2568,87.098 72,78.5C 71.1816,72.6513 71.3483,66.9846 72.5,61.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7b72d",
    d: "M 74.5,43.5 C 74.9382,43.4346 75.2716,43.6012 75.5,44C 72.133,48.3798 69.133,53.0465 66.5,58C 75.5671,99.8001 69.9005,139.467 49.5,177C 50.056,177.383 50.3893,177.883 50.5,178.5C 47.082,177.361 43.7487,176.028 40.5,174.5C 58.9954,141.043 65.3287,105.377 59.5,67.5C 61.0478,63.9393 63.0478,60.606 65.5,57.5C 64.164,54.8463 62.4974,52.513 60.5,50.5C 64.8489,47.6589 69.5156,45.3255 74.5,43.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9cb67",
    d: "M 42.5,61.5 C 43.8221,61.33 44.9887,61.6634 46,62.5C 48.5269,66.8961 51.0269,71.2295 53.5,75.5C 52.2271,77.7128 51.2271,80.0462 50.5,82.5C 48.2519,85.328 46.2519,88.328 44.5,91.5C 42.2275,84.9519 39.3942,78.6186 36,72.5C 35.2411,70.9371 34.0744,69.9371 32.5,69.5C 35.429,66.3637 38.7623,63.697 42.5,61.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.934
    },
    fill: "#de69a8",
    d: "M 225.5,65.5 C 225.039,67.5504 224.372,69.5504 223.5,71.5C 226.642,72.1674 229.642,72.834 232.5,73.5C 223.041,73.0437 213.708,73.877 204.5,76C 200.655,77.4198 197.322,79.5865 194.5,82.5C 197.13,83.3815 199.797,84.0481 202.5,84.5C 196.913,94.6796 190.579,104.346 183.5,113.5C 174.421,86.6693 184.088,70.836 212.5,66C 216.821,65.501 221.154,65.3343 225.5,65.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.949
    },
    fill: "#d54794",
    d: "M 225.5,65.5 C 240.518,65.105 254.851,67.7717 268.5,73.5C 268.233,75.9653 267.566,78.2986 266.5,80.5C 262.777,79.7033 259.11,78.7033 255.5,77.5C 248.908,75.7816 242.242,74.4483 235.5,73.5C 234.5,73.5 233.5,73.5 232.5,73.5C 229.642,72.834 226.642,72.1674 223.5,71.5C 224.372,69.5504 225.039,67.5504 225.5,65.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fad077",
    d: "M 32.5,69.5 C 34.0744,69.9371 35.2411,70.9371 36,72.5C 39.3942,78.6186 42.2275,84.9519 44.5,91.5C 43.8333,93.5 43.1667,95.5 42.5,97.5C 40.8998,99.7026 39.5665,102.036 38.5,104.5C 37.075,94.3919 33.575,85.0586 28,76.5C 27.3292,75.7476 26.4959,75.4142 25.5,75.5C 27.2193,72.7805 29.5526,70.7805 32.5,69.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eba5ca",
    d: "M 232.5,73.5 C 233.5,73.5 234.5,73.5 235.5,73.5C 235.611,74.1174 235.944,74.6174 236.5,75C 226.497,77.737 216.83,80.9037 207.5,84.5C 205.833,84.5 204.167,84.5 202.5,84.5C 199.797,84.0481 197.13,83.3815 194.5,82.5C 197.322,79.5865 200.655,77.4198 204.5,76C 213.708,73.877 223.041,73.0437 232.5,73.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7bb39",
    d: "M 59.5,67.5 C 65.3287,105.377 58.9954,141.043 40.5,174.5C 37.8333,173.167 35.1667,171.833 32.5,170.5C 35.9813,162.199 39.4813,153.865 43,145.5C 50.2027,124.887 52.7027,103.887 50.5,82.5C 51.2271,80.0462 52.2271,77.7128 53.5,75.5C 55.5,72.8333 57.5,70.1667 59.5,67.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e89ac4",
    d: "M 235.5,73.5 C 242.242,74.4483 248.908,75.7816 255.5,77.5C 245.702,81.8792 235.369,85.2125 224.5,87.5C 221.794,87.4249 219.127,87.0916 216.5,86.5C 213.546,85.7287 210.546,85.062 207.5,84.5C 216.83,80.9037 226.497,77.737 236.5,75C 235.944,74.6174 235.611,74.1174 235.5,73.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.944
    },
    fill: "#c74090",
    d: "M 268.5,73.5 C 277.532,76.1836 285.865,80.1836 293.5,85.5C 292.305,87.7513 291.305,90.0846 290.5,92.5C 288.517,91.5294 286.517,90.5294 284.5,89.5C 278.435,86.4673 272.435,83.4673 266.5,80.5C 267.566,78.2986 268.233,75.9653 268.5,73.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fad689",
    d: "M 25.5,75.5 C 26.4959,75.4142 27.3292,75.7476 28,76.5C 33.575,85.0586 37.075,94.3919 38.5,104.5C 33.7396,116.698 29.7396,129.031 26.5,141.5C 30.8138,121.387 27.9804,102.387 18,84.5C 17.6174,85.056 17.1174,85.3893 16.5,85.5C 18.7657,81.5644 21.7657,78.2311 25.5,75.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8bf43",
    d: "M 50.5,82.5 C 52.7027,103.887 50.2027,124.887 43,145.5C 39.4813,153.865 35.9813,162.199 32.5,170.5C 29.8333,168.833 27.1667,167.167 24.5,165.5C 24.5,164.5 24.5,163.5 24.5,162.5C 35.9312,142.453 41.9312,120.787 42.5,97.5C 43.1667,95.5 43.8333,93.5 44.5,91.5C 46.2519,88.328 48.2519,85.328 50.5,82.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbd991",
    d: "M 26.5,141.5 C 26.0729,148.532 25.4062,155.532 24.5,162.5C 24.5,163.5 24.5,164.5 24.5,165.5C 21.1124,162.779 18.1124,159.779 15.5,156.5C 27.1024,134.373 27.4357,112.04 16.5,89.5C 15.5754,88.4376 14.5754,88.4376 13.5,89.5C 13.7376,87.5956 14.7376,86.2623 16.5,85.5C 17.1174,85.3893 17.6174,85.056 18,84.5C 27.9804,102.387 30.8138,121.387 26.5,141.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#db5ca0",
    d: "M 202.5,84.5 C 204.167,84.5 205.833,84.5 207.5,84.5C 210.546,85.062 213.546,85.7287 216.5,86.5C 209.214,100.757 200.214,113.757 189.5,125.5C 186.46,122.086 184.46,118.086 183.5,113.5C 190.579,104.346 196.913,94.6796 202.5,84.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d85099",
    d: "M 216.5,86.5 C 219.127,87.0916 221.794,87.4249 224.5,87.5C 227.465,88.6255 230.465,89.6255 233.5,90.5C 226.525,105.118 218.025,118.785 208,131.5C 206.223,133.79 204.056,135.457 201.5,136.5C 197.833,133.833 194.167,131.167 190.5,128.5C 189.89,127.609 189.557,126.609 189.5,125.5C 200.214,113.757 209.214,100.757 216.5,86.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e289ba",
    d: "M 255.5,77.5 C 259.11,78.7033 262.777,79.7033 266.5,80.5C 272.435,83.4673 278.435,86.4673 284.5,89.5C 282.458,91.8297 279.792,92.9964 276.5,93C 266.839,93.4998 257.172,93.6665 247.5,93.5C 242.839,92.5028 238.173,91.5028 233.5,90.5C 230.465,89.6255 227.465,88.6255 224.5,87.5C 235.369,85.2125 245.702,81.8792 255.5,77.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbdd9b",
    d: "M 15.5,156.5 C 12.5389,154.588 10.5389,151.921 9.5,148.5C 17.2833,131.362 17.45,114.028 10,96.5C 3.35333,107.564 0.853331,119.564 2.5,132.5C 1.5,132.5 0.5,132.5 -0.5,132.5C -0.5,127.5 -0.5,122.5 -0.5,117.5C 1.75595,109.593 4.92262,101.926 9,94.5C 10.0491,92.3825 11.5491,90.7158 13.5,89.5C 14.5754,88.4376 15.5754,88.4376 16.5,89.5C 27.4357,112.04 27.1024,134.373 15.5,156.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d44291",
    d: "M 233.5,90.5 C 238.173,91.5028 242.839,92.5028 247.5,93.5C 251.083,95.3604 254.749,97.0271 258.5,98.5C 250.315,116.374 239.982,132.874 227.5,148C 223.302,148.05 219.302,147.05 215.5,145C 210.97,142.235 206.303,139.735 201.5,137.5C 201.5,137.167 201.5,136.833 201.5,136.5C 204.056,135.457 206.223,133.79 208,131.5C 218.025,118.785 226.525,105.118 233.5,90.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.944
    },
    fill: "#bb3e90",
    d: "M 293.5,85.5 C 301.341,89.3432 308.341,94.3432 314.5,100.5C 312.69,103.145 311.69,106.145 311.5,109.5C 310.833,109.167 310.167,108.833 309.5,108.5C 307.761,105.757 305.427,103.757 302.5,102.5C 298.792,98.7899 294.792,95.4566 290.5,92.5C 291.305,90.0846 292.305,87.7513 293.5,85.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d77bb3",
    d: "M 284.5,89.5 C 286.517,90.5294 288.517,91.5294 290.5,92.5C 294.792,95.4566 298.792,98.7899 302.5,102.5C 298.752,104.053 294.752,104.719 290.5,104.5C 284.354,102.959 277.354,102.293 269.5,102.5C 265.833,101.167 262.167,99.8333 258.5,98.5C 254.749,97.0271 251.083,95.3604 247.5,93.5C 257.172,93.6665 266.839,93.4998 276.5,93C 279.792,92.9964 282.458,91.8297 284.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fce2a9",
    d: "M 9.5,148.5 C 8.17589,147.065 6.50922,146.065 4.5,145.5C 3.61432,146.325 3.28099,147.325 3.5,148.5C 1.9679,145.235 0.634569,141.902 -0.5,138.5C -0.5,136.5 -0.5,134.5 -0.5,132.5C 0.5,132.5 1.5,132.5 2.5,132.5C 0.853331,119.564 3.35333,107.564 10,96.5C 17.45,114.028 17.2833,131.362 9.5,148.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8c350",
    d: "M 42.5,97.5 C 41.9312,120.787 35.9312,142.453 24.5,162.5C 25.4062,155.532 26.0729,148.532 26.5,141.5C 29.7396,129.031 33.7396,116.698 38.5,104.5C 39.5665,102.036 40.8998,99.7026 42.5,97.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c83e90",
    d: "M 258.5,98.5 C 262.167,99.8333 265.833,101.167 269.5,102.5C 274.001,104.916 278.334,107.583 282.5,110.5C 274.155,128.442 264.488,144.108 253.5,157.5C 253.557,158.609 253.89,159.609 254.5,160.5C 245.285,158.095 236.285,155.095 227.5,151.5C 217.901,148.37 209.234,143.703 201.5,137.5C 206.303,139.735 210.97,142.235 215.5,145C 219.302,147.05 223.302,148.05 227.5,148C 239.982,132.874 250.315,116.374 258.5,98.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.908
    },
    fill: "#e1a02a",
    d: "M 456.5,103.5 C 463.856,102.768 470.856,103.934 477.5,107C 483.186,110.538 486.186,115.705 486.5,122.5C 482.116,122.826 477.783,122.492 473.5,121.5C 469.074,113.314 462.741,111.481 454.5,116C 450.247,120.663 450.58,124.997 455.5,129C 463.118,131.821 470.784,134.487 478.5,137C 486.114,142.208 488.614,149.374 486,158.5C 481.708,168.074 474.208,172.741 463.5,172.5C 449.403,172.824 441.403,166.157 439.5,152.5C 443.833,152.5 448.167,152.5 452.5,152.5C 452.935,159.239 456.602,162.572 463.5,162.5C 474.128,161.425 477.128,156.258 472.5,147C 463.833,143.667 455.167,140.333 446.5,137C 437.576,128.021 437.243,118.687 445.5,109C 448.99,106.588 452.657,104.755 456.5,103.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.916
    },
    fill: "#e1a02a",
    d: "M 528.5,103.5 C 560.609,104.055 573.443,120.055 567,151.5C 559.326,167.808 546.493,174.641 528.5,172C 508.403,166.553 499.236,153.386 501,132.5C 503.896,116.773 513.062,107.107 528.5,103.5 Z M 532.5,113.5 C 552.895,115.92 560.729,127.253 556,147.5C 550.36,160.05 540.86,164.55 527.5,161C 517.504,156.693 512.504,149.026 512.5,138C 512.875,124.476 519.542,116.31 532.5,113.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4ab25",
    d: "M 78.5,103.5 C 80.7505,106.999 82.7505,110.665 84.5,114.5C 81.727,138.153 74.727,160.486 63.5,181.5C 63.8627,182.183 64.1961,182.85 64.5,183.5C 64.1667,183.5 63.8333,183.5 63.5,183.5C 61.0128,182.677 58.6794,181.677 56.5,180.5C 69.886,156.632 77.2193,130.965 78.5,103.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d06fac",
    d: "M 269.5,102.5 C 277.354,102.293 284.354,102.959 290.5,104.5C 294.752,104.719 298.752,104.053 302.5,102.5C 305.427,103.757 307.761,105.757 309.5,108.5C 309.389,109.117 309.056,109.617 308.5,110C 301.119,110.235 293.786,110.735 286.5,111.5C 285.167,111.167 283.833,110.833 282.5,110.5C 278.334,107.583 274.001,104.916 269.5,102.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.944
    },
    fill: "#e1a02a",
    d: "M 584.5,104.5 C 597.833,104.5 611.167,104.5 624.5,104.5C 624.5,107.833 624.5,111.167 624.5,114.5C 614.833,114.5 605.167,114.5 595.5,114.5C 595.5,120.833 595.5,127.167 595.5,133.5C 603.167,133.5 610.833,133.5 618.5,133.5C 618.5,136.5 618.5,139.5 618.5,142.5C 610.833,142.5 603.167,142.5 595.5,142.5C 595.5,152.167 595.5,161.833 595.5,171.5C 591.833,171.5 588.167,171.5 584.5,171.5C 584.5,149.167 584.5,126.833 584.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.902
    },
    fill: "#e1a02a",
    d: "M 634.5,104.5 C 650.5,104.5 666.5,104.5 682.5,104.5C 682.5,107.833 682.5,111.167 682.5,114.5C 676.5,114.5 670.5,114.5 664.5,114.5C 664.5,133.5 664.5,152.5 664.5,171.5C 660.5,171.5 656.5,171.5 652.5,171.5C 652.5,152.5 652.5,133.5 652.5,114.5C 646.5,114.5 640.5,114.5 634.5,114.5C 634.5,111.167 634.5,107.833 634.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.921
    },
    fill: "#e1a02a",
    d: "M 691.5,105.5 C 695.634,104.515 699.968,104.182 704.5,104.5C 708.686,121.911 713.186,139.245 718,156.5C 722.511,139.456 727.178,122.456 732,105.5C 736.401,104.533 740.901,104.2 745.5,104.5C 749.684,121.9 754.184,139.234 759,156.5C 763.177,139.457 767.511,122.457 772,105.5C 776.066,104.536 780.233,104.203 784.5,104.5C 778.322,126.878 771.989,149.211 765.5,171.5C 760.833,171.5 756.167,171.5 751.5,171.5C 747.624,155.33 743.124,139.33 738,123.5C 733.186,139.437 728.686,155.437 724.5,171.5C 719.786,171.827 715.12,171.493 710.5,170.5C 704.329,148.667 697.996,127 691.5,105.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.917
    },
    fill: "#e1a02a",
    d: "M 816.5,104.5 C 821.179,104.334 825.845,104.501 830.5,105C 838.63,126.764 846.63,148.597 854.5,170.5C 850.217,171.492 845.884,171.826 841.5,171.5C 840.668,167.17 839.335,163.004 837.5,159C 828.5,158.333 819.5,158.333 810.5,159C 808.638,162.919 806.971,166.919 805.5,171C 801.459,171.827 797.459,171.66 793.5,170.5C 801.572,148.615 809.239,126.615 816.5,104.5 Z M 823.5,119.5 C 827.603,128.805 830.936,138.471 833.5,148.5C 826.825,148.666 820.158,148.5 813.5,148C 817.332,138.67 820.666,129.17 823.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.934
    },
    fill: "#e1a02a",
    d: "M 869.5,104.5 C 879.506,104.334 889.506,104.5 899.5,105C 914.18,109.186 919.346,118.686 915,133.5C 912.614,139.104 908.447,142.437 902.5,143.5C 906.821,152.97 911.821,162.136 917.5,171C 912.833,171.667 908.167,171.667 903.5,171C 898.633,162.962 893.967,154.795 889.5,146.5C 886.572,145.516 883.572,145.183 880.5,145.5C 880.5,154.167 880.5,162.833 880.5,171.5C 876.833,171.5 873.167,171.5 869.5,171.5C 869.5,149.167 869.5,126.833 869.5,104.5 Z M 880.5,114.5 C 886.509,114.334 892.509,114.501 898.5,115C 905.062,119.599 906.229,125.432 902,132.5C 900.581,133.46 899.081,134.293 897.5,135C 891.843,135.499 886.176,135.666 880.5,135.5C 880.5,128.5 880.5,121.5 880.5,114.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.965
    },
    fill: "#e1a02a",
    d: "M 934.5,104.5 C 946.833,104.5 959.167,104.5 971.5,104.5C 971.5,107.5 971.5,110.5 971.5,113.5C 962.833,113.5 954.167,113.5 945.5,113.5C 945.5,119.833 945.5,126.167 945.5,132.5C 953.167,132.5 960.833,132.5 968.5,132.5C 968.5,135.833 968.5,139.167 968.5,142.5C 960.833,142.5 953.167,142.5 945.5,142.5C 945.5,149.167 945.5,155.833 945.5,162.5C 954.167,162.5 962.833,162.5 971.5,162.5C 971.5,165.5 971.5,168.5 971.5,171.5C 959.167,171.5 946.833,171.5 934.5,171.5C 934.5,149.167 934.5,126.833 934.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2a525",
    d: "M 84.5,114.5 C 86.653,116.794 88.3197,119.46 89.5,122.5C 86.6408,144.41 79.9741,165.077 69.5,184.5C 67.7839,184.371 66.1172,184.038 64.5,183.5C 64.1961,182.85 63.8627,182.183 63.5,181.5C 74.727,160.486 81.727,138.153 84.5,114.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c360a4",
    d: "M 309.5,108.5 C 310.167,108.833 310.833,109.167 311.5,109.5C 315.21,113.208 318.543,117.208 321.5,121.5C 315.927,124.143 309.927,125.143 303.5,124.5C 297.615,120.398 291.948,116.064 286.5,111.5C 293.786,110.735 301.119,110.235 308.5,110C 309.056,109.617 309.389,109.117 309.5,108.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ba3d8f",
    d: "M 282.5,110.5 C 283.833,110.833 285.167,111.167 286.5,111.5C 291.948,116.064 297.615,120.398 303.5,124.5C 303.5,124.833 303.5,125.167 303.5,125.5C 296.663,138.67 288.996,151.337 280.5,163.5C 271.503,161.5 262.503,159.5 253.5,157.5C 264.488,144.108 274.155,128.442 282.5,110.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f09f25",
    d: "M 89.5,122.5 C 91.8532,124.86 93.8532,127.527 95.5,130.5C 91.556,149.999 85.2227,168.666 76.5,186.5C 73.9327,186.279 71.5994,185.612 69.5,184.5C 79.9741,165.077 86.6408,144.41 89.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.984
    },
    fill: "#a93c8f",
    d: "M 314.5,100.5 C 325.777,110.779 334.777,122.779 341.5,136.5C 334.768,148.961 327.768,161.294 320.5,173.5C 317.598,172.422 314.598,171.756 311.5,171.5C 307.004,169.873 302.337,168.54 297.5,167.5C 297.389,166.883 297.056,166.383 296.5,166C 303.662,156.178 309.662,145.678 314.5,134.5C 319.119,133.686 323.786,133.353 328.5,133.5C 327,129.003 324.667,125.003 321.5,121.5C 318.543,117.208 315.21,113.208 311.5,109.5C 311.69,106.145 312.69,103.145 314.5,100.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b23c8f",
    d: "M 303.5,125.5 C 307.457,128.122 311.124,131.122 314.5,134.5C 309.662,145.678 303.662,156.178 296.5,166C 297.056,166.383 297.389,166.883 297.5,167.5C 294.539,166.677 291.539,166.01 288.5,165.5C 285.997,164.629 283.33,163.963 280.5,163.5C 288.996,151.337 296.663,138.67 303.5,125.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b7509a",
    d: "M 321.5,121.5 C 324.667,125.003 327,129.003 328.5,133.5C 323.786,133.353 319.119,133.686 314.5,134.5C 311.124,131.122 307.457,128.122 303.5,125.5C 303.5,125.167 303.5,124.833 303.5,124.5C 309.927,125.143 315.927,124.143 321.5,121.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ee9925",
    d: "M 95.5,130.5 C 97.8532,132.86 99.8532,135.527 101.5,138.5C 97.3106,155.728 91.3106,172.395 83.5,188.5C 82.0413,188.567 80.7079,188.234 79.5,187.5C 78.209,187.737 77.209,187.404 76.5,186.5C 85.2227,168.666 91.556,149.999 95.5,130.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.981
    },
    fill: "#9e3a8f",
    d: "M 341.5,136.5 C 348.631,152.361 352.297,169.027 352.5,186.5C 344.777,182.59 336.777,179.256 328.5,176.5C 325.919,175.512 323.252,174.512 320.5,173.5C 327.768,161.294 334.768,148.961 341.5,136.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eb8e24",
    d: "M 101.5,138.5 C 104.805,142.141 108.138,145.808 111.5,149.5C 108.192,164.113 103.192,178.113 96.5,191.5C 96.1667,191.5 95.8333,191.5 95.5,191.5C 91.4793,190.497 87.4793,189.497 83.5,188.5C 91.3106,172.395 97.3106,155.728 101.5,138.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.972
    },
    fill: "#8a378e",
    d: "M 190.5,128.5 C 194.167,131.167 197.833,133.833 201.5,136.5C 201.5,136.833 201.5,137.167 201.5,137.5C 209.234,143.703 217.901,148.37 227.5,151.5C 226.23,156.312 224.563,160.978 222.5,165.5C 210.368,154.373 199.701,142.039 190.5,128.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fce8be",
    d: "M 9.5,148.5 C 10.5389,151.921 12.5389,154.588 15.5,156.5C 18.1124,159.779 21.1124,162.779 24.5,165.5C 27.1667,167.167 29.8333,168.833 32.5,170.5C 35.1667,171.833 37.8333,173.167 40.5,174.5C 43.7487,176.028 47.082,177.361 50.5,178.5C 50.5394,179.583 50.8728,180.583 51.5,181.5C 50.675,182.386 49.675,182.719 48.5,182.5C 47.391,182.443 46.391,182.11 45.5,181.5C 37.7063,179.127 30.373,175.793 23.5,171.5C 13.9705,166.305 7.30388,158.638 3.5,148.5C 3.28099,147.325 3.61432,146.325 4.5,145.5C 6.50922,146.065 8.17589,147.065 9.5,148.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e78224",
    d: "M 111.5,149.5 C 115.472,153.807 119.472,158.141 123.5,162.5C 119.772,173.619 115.772,184.619 111.5,195.5C 106.354,194.631 101.354,193.297 96.5,191.5C 103.192,178.113 108.192,164.113 111.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.976
    },
    fill: "#9c398f",
    d: "M 227.5,151.5 C 236.285,155.095 245.285,158.095 254.5,160.5C 250.377,169.203 247.043,178.203 244.5,187.5C 244.167,187.5 243.833,187.5 243.5,187.5C 235.798,180.799 228.798,173.466 222.5,165.5C 224.563,160.978 226.23,156.312 227.5,151.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e47924",
    d: "M 123.5,162.5 C 125.5,163.833 127.167,165.5 128.5,167.5C 125.815,177.372 122.148,186.872 117.5,196C 118.056,196.383 118.389,196.883 118.5,197.5C 116.106,196.985 113.772,196.319 111.5,195.5C 115.772,184.619 119.772,173.619 123.5,162.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#a93b8f",
    d: "M 254.5,160.5 C 260.126,161.99 265.793,163.323 271.5,164.5C 266.231,176.355 261.564,188.355 257.5,200.5C 252.833,196.5 248.5,192.167 244.5,187.5C 247.043,178.203 250.377,169.203 254.5,160.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#da69a8",
    d: "M 253.5,157.5 C 262.503,159.5 271.503,161.5 280.5,163.5C 283.33,163.963 285.997,164.629 288.5,165.5C 286.62,165.229 285.287,165.896 284.5,167.5C 283.833,167.5 283.167,167.5 282.5,167.5C 278.773,166.652 275.107,165.652 271.5,164.5C 265.793,163.323 260.126,161.99 254.5,160.5C 253.89,159.609 253.557,158.609 253.5,157.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#b13c8f",
    d: "M 271.5,164.5 C 275.107,165.652 278.773,166.652 282.5,167.5C 275.21,181.084 269.877,195.418 266.5,210.5C 262.788,207.789 259.788,204.456 257.5,200.5C 261.564,188.355 266.231,176.355 271.5,164.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bc3d8f",
    d: "M 282.5,167.5 C 283.167,167.5 283.833,167.5 284.5,167.5C 289.272,169.278 294.272,170.611 299.5,171.5C 290.781,189.323 284.448,207.989 280.5,227.5C 275.863,221.858 271.197,216.191 266.5,210.5C 269.877,195.418 275.21,181.084 282.5,167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e58ebd",
    d: "M 288.5,165.5 C 291.539,166.01 294.539,166.677 297.5,167.5C 302.337,168.54 307.004,169.873 311.5,171.5C 311.433,172.959 311.766,174.292 312.5,175.5C 311.167,175.167 309.833,174.833 308.5,174.5C 305.579,173.304 302.579,172.304 299.5,171.5C 294.272,170.611 289.272,169.278 284.5,167.5C 285.287,165.896 286.62,165.229 288.5,165.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.988
    },
    fill: "#e16f24",
    d: "M 128.5,167.5 C 129.5,168.167 130.5,168.833 131.5,169.5C 134.138,172.474 136.805,175.474 139.5,178.5C 136.52,185.757 133.52,193.091 130.5,200.5C 126.761,199.697 123.095,198.697 119.5,197.5C 119.167,197.5 118.833,197.5 118.5,197.5C 118.389,196.883 118.056,196.383 117.5,196C 122.148,186.872 125.815,177.372 128.5,167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c43e90",
    d: "M 299.5,171.5 C 302.579,172.304 305.579,173.304 308.5,174.5C 297.217,194.352 290.55,215.685 288.5,238.5C 285.112,235.403 282.445,231.736 280.5,227.5C 284.448,207.989 290.781,189.323 299.5,171.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cb3f90",
    d: "M 308.5,174.5 C 309.833,174.833 311.167,175.167 312.5,175.5C 315.252,176.512 317.919,177.512 320.5,178.5C 318.983,178.511 317.816,179.177 317,180.5C 305.34,203.474 298.506,227.807 296.5,253.5C 293.582,248.667 290.916,243.667 288.5,238.5C 290.55,215.685 297.217,194.352 308.5,174.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eba8cc",
    d: "M 311.5,171.5 C 314.598,171.756 317.598,172.422 320.5,173.5C 323.252,174.512 325.919,175.512 328.5,176.5C 327.566,177.568 327.232,178.901 327.5,180.5C 327.167,180.5 326.833,180.5 326.5,180.5C 324.703,179.27 322.703,178.604 320.5,178.5C 317.919,177.512 315.252,176.512 312.5,175.5C 311.766,174.292 311.433,172.959 311.5,171.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.973
    },
    fill: "#de6524",
    d: "M 23.5,171.5 C 30.373,175.793 37.7063,179.127 45.5,181.5C 40.2448,191.01 35.2448,200.676 30.5,210.5C 25.9209,198.036 23.5876,185.036 23.5,171.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d13f90",
    d: "M 320.5,178.5 C 322.703,178.604 324.703,179.27 326.5,180.5C 305.843,218.76 300.176,259.093 309.5,301.5C 306.638,305.195 303.972,309.029 301.5,313C 302.448,313.483 303.448,313.649 304.5,313.5C 302.819,315.008 300.819,316.008 298.5,316.5C 298.062,316.565 297.728,316.399 297.5,316C 298.971,314.417 299.971,312.583 300.5,310.5C 306.804,290.963 305.47,271.963 296.5,253.5C 298.506,227.807 305.34,203.474 317,180.5C 317.816,179.177 318.983,178.511 320.5,178.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbdb99",
    d: "M 50.5,178.5 C 52.4214,179.363 54.4214,180.029 56.5,180.5C 58.6794,181.677 61.0128,182.677 63.5,183.5C 63.7148,185.179 63.0481,186.179 61.5,186.5C 56.9281,185.612 52.5948,184.279 48.5,182.5C 49.675,182.719 50.675,182.386 51.5,181.5C 50.8728,180.583 50.5394,179.583 50.5,178.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d64894",
    d: "M 326.5,180.5 C 326.833,180.5 327.167,180.5 327.5,180.5C 332.48,182.323 337.147,184.657 341.5,187.5C 324.738,217.308 318.071,249.308 321.5,283.5C 320.89,284.391 320.557,285.391 320.5,286.5C 317.363,290.485 314.363,294.652 311.5,299C 313.178,301.914 315.178,304.414 317.5,306.5C 313.653,309.593 309.32,311.926 304.5,313.5C 303.448,313.649 302.448,313.483 301.5,313C 303.972,309.029 306.638,305.195 309.5,301.5C 300.176,259.093 305.843,218.76 326.5,180.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.972
    },
    fill: "#dd6224",
    d: "M 139.5,178.5 C 145.167,183.5 150.5,188.833 155.5,194.5C 153.036,198.444 151.37,202.777 150.5,207.5C 143.833,205.167 137.167,202.833 130.5,200.5C 133.52,193.091 136.52,185.757 139.5,178.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#e17124",
    d: "M 45.5,181.5 C 46.391,182.11 47.391,182.443 48.5,182.5C 52.5948,184.279 56.9281,185.612 61.5,186.5C 62.209,187.404 63.209,187.737 64.5,187.5C 59.093,195.974 53.9263,204.64 49,213.5C 47.0679,215.038 44.9012,216.205 42.5,217C 43.3578,218.57 44.0245,220.237 44.5,222C 43.0137,225.135 41.6804,228.302 40.5,231.5C 35.8495,225.196 32.5162,218.196 30.5,210.5C 35.2448,200.676 40.2448,191.01 45.5,181.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2c5dd",
    d: "M 328.5,176.5 C 336.777,179.256 344.777,182.59 352.5,186.5C 362.433,192.77 369.433,201.436 373.5,212.5C 373.5,213.5 373.5,214.5 373.5,215.5C 372.022,215.762 370.689,215.429 369.5,214.5C 369.058,213.261 368.391,212.261 367.5,211.5C 365.366,206.226 362.033,201.893 357.5,198.5C 356.109,196.11 354.109,194.443 351.5,193.5C 351.5,192.833 351.167,192.5 350.5,192.5C 347.992,190.076 344.992,188.41 341.5,187.5C 337.147,184.657 332.48,182.323 327.5,180.5C 327.232,178.901 327.566,177.568 328.5,176.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9d281",
    d: "M 63.5,183.5 C 63.8333,183.5 64.1667,183.5 64.5,183.5C 66.1172,184.038 67.7839,184.371 69.5,184.5C 71.5994,185.612 73.9327,186.279 76.5,186.5C 77.209,187.404 78.209,187.737 79.5,187.5C 79.7148,189.179 79.0481,190.179 77.5,190.5C 76.1667,190.5 74.8333,190.5 73.5,190.5C 70.5482,189.346 67.5482,188.346 64.5,187.5C 63.209,187.737 62.209,187.404 61.5,186.5C 63.0481,186.179 63.7148,185.179 63.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e47a24",
    d: "M 64.5,187.5 C 67.5482,188.346 70.5482,189.346 73.5,190.5C 67.9697,199.722 62.303,208.889 56.5,218C 57.3805,218.708 58.0472,219.542 58.5,220.5C 54.8117,222.652 50.8117,223.986 46.5,224.5C 49.1127,230.082 52.446,235.082 56.5,239.5C 56.8333,240.167 57.1667,240.833 57.5,241.5C 56.7866,244.594 55.7866,247.594 54.5,250.5C 48.6155,245.065 43.9489,238.731 40.5,231.5C 41.6804,228.302 43.0137,225.135 44.5,222C 44.0245,220.237 43.3578,218.57 42.5,217C 44.9012,216.205 47.0679,215.038 49,213.5C 53.9263,204.64 59.093,195.974 64.5,187.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#da579d",
    d: "M 341.5,187.5 C 344.992,188.41 347.992,190.076 350.5,192.5C 337.918,214.827 331.585,238.827 331.5,264.5C 329.833,268.5 328.167,272.5 326.5,276.5C 324.588,278.657 322.921,280.991 321.5,283.5C 318.071,249.308 324.738,217.308 341.5,187.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e68024",
    d: "M 73.5,190.5 C 74.8333,190.5 76.1667,190.5 77.5,190.5C 79.6568,191.407 81.9902,192.073 84.5,192.5C 77.6718,203.483 71.3385,214.816 65.5,226.5C 63.1667,224.5 60.8333,222.5 58.5,220.5C 58.0472,219.542 57.3805,218.708 56.5,218C 62.303,208.889 67.9697,199.722 73.5,190.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8c969",
    d: "M 79.5,187.5 C 80.7079,188.234 82.0413,188.567 83.5,188.5C 87.4793,189.497 91.4793,190.497 95.5,191.5C 96.625,192.652 96.625,193.652 95.5,194.5C 95.1667,194.5 94.8333,194.5 94.5,194.5C 91.0945,194.044 87.7611,193.378 84.5,192.5C 81.9902,192.073 79.6568,191.407 77.5,190.5C 79.0481,190.179 79.7148,189.179 79.5,187.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e88624",
    d: "M 84.5,192.5 C 87.7611,193.378 91.0945,194.044 94.5,194.5C 86.8301,207.175 79.1634,219.841 71.5,232.5C 70.8333,232.167 70.1667,231.833 69.5,231.5C 68.1667,229.833 66.8333,228.167 65.5,226.5C 71.3385,214.816 77.6718,203.483 84.5,192.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ea8c24",
    d: "M 94.5,194.5 C 94.8333,194.5 95.1667,194.5 95.5,194.5C 97.9052,195.768 100.572,196.435 103.5,196.5C 103.611,197.117 103.944,197.617 104.5,198C 95.264,210.978 86.9307,224.478 79.5,238.5C 76.5451,236.878 73.8785,234.878 71.5,232.5C 79.1634,219.841 86.8301,207.175 94.5,194.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e898c3",
    d: "M 351.5,193.5 C 354.109,194.443 356.109,196.11 357.5,198.5C 347.769,218.762 345.936,239.762 352,261.5C 353.393,265.286 355.059,268.952 357,272.5C 357.671,273.252 358.504,273.586 359.5,273.5C 358.167,275.5 356.5,277.167 354.5,278.5C 346.816,267.128 342.816,254.461 342.5,240.5C 347.445,225.224 350.445,209.557 351.5,193.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7c04c",
    d: "M 95.5,191.5 C 95.8333,191.5 96.1667,191.5 96.5,191.5C 101.354,193.297 106.354,194.631 111.5,195.5C 113.772,196.319 116.106,196.985 118.5,197.5C 118.833,197.5 119.167,197.5 119.5,197.5C 119.672,198.492 119.338,199.158 118.5,199.5C 116.5,199.167 114.5,198.833 112.5,198.5C 109.402,198.244 106.402,197.578 103.5,196.5C 100.572,196.435 97.9052,195.768 95.5,194.5C 96.625,193.652 96.625,192.652 95.5,191.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ec9225",
    d: "M 103.5,196.5 C 106.402,197.578 109.402,198.244 112.5,198.5C 112.918,199.222 113.584,199.722 114.5,200C 109.544,206.746 104.71,213.579 100,220.5C 95.9779,228.559 91.4779,236.225 86.5,243.5C 83.6298,242.567 81.2964,240.9 79.5,238.5C 86.9307,224.478 95.264,210.978 104.5,198C 103.944,197.617 103.611,197.117 103.5,196.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.987
    },
    fill: "#98398f",
    d: "M 243.5,187.5 C 243.833,187.5 244.167,187.5 244.5,187.5C 248.5,192.167 252.833,196.5 257.5,200.5C 259.788,204.456 262.788,207.789 266.5,210.5C 271.197,216.191 275.863,221.858 280.5,227.5C 282.445,231.736 285.112,235.403 288.5,238.5C 290.916,243.667 293.582,248.667 296.5,253.5C 305.47,271.963 306.804,290.963 300.5,310.5C 289.835,284.832 276.835,260.498 261.5,237.5C 259.647,219.269 253.647,202.603 243.5,187.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ee9925",
    d: "M 112.5,198.5 C 114.5,198.833 116.5,199.167 118.5,199.5C 120.905,200.768 123.572,201.435 126.5,201.5C 121.178,207.34 116.345,213.673 112,220.5C 106.299,229.903 101.132,239.57 96.5,249.5C 92.8832,248.358 89.5498,246.692 86.5,244.5C 86.5,244.167 86.5,243.833 86.5,243.5C 91.4779,236.225 95.9779,228.559 100,220.5C 104.71,213.579 109.544,206.746 114.5,200C 113.584,199.722 112.918,199.222 112.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dc62a3",
    d: "M 350.5,192.5 C 351.167,192.5 351.5,192.833 351.5,193.5C 350.445,209.557 347.445,225.224 342.5,240.5C 340.188,246.424 337.854,252.424 335.5,258.5C 334.167,260.5 332.833,262.5 331.5,264.5C 331.585,238.827 337.918,214.827 350.5,192.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f09f25",
    d: "M 126.5,201.5 C 129.26,202.192 131.927,203.192 134.5,204.5C 122.921,220.072 112.587,236.406 103.5,253.5C 101.046,252.773 98.7128,251.773 96.5,250.5C 96.5,250.167 96.5,249.833 96.5,249.5C 101.132,239.57 106.299,229.903 112,220.5C 116.345,213.673 121.178,207.34 126.5,201.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eba5ca",
    d: "M 357.5,198.5 C 362.033,201.893 365.366,206.226 367.5,211.5C 361.083,227.763 360.916,244.096 367,260.5C 370.553,254.304 372.886,247.637 374,240.5C 374.333,239.833 374.667,239.167 375,238.5C 375.278,239.416 375.778,240.082 376.5,240.5C 373.705,253.093 368.038,264.093 359.5,273.5C 358.504,273.586 357.671,273.252 357,272.5C 355.059,268.952 353.393,265.286 352,261.5C 345.936,239.762 347.769,218.762 357.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1a425",
    d: "M 119.5,197.5 C 123.095,198.697 126.761,199.697 130.5,200.5C 137.167,202.833 143.833,205.167 150.5,207.5C 158.771,209.965 166.104,213.965 172.5,219.5C 169.648,217.909 166.648,216.576 163.5,215.5C 160.744,213.796 157.744,212.463 154.5,211.5C 151.346,209.998 148.013,208.664 144.5,207.5C 131.986,223.203 120.986,239.87 111.5,257.5C 108.515,256.674 105.849,255.341 103.5,253.5C 112.587,236.406 122.921,220.072 134.5,204.5C 131.927,203.192 129.26,202.192 126.5,201.5C 123.572,201.435 120.905,200.768 118.5,199.5C 119.338,199.158 119.672,198.492 119.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4ab25",
    d: "M 154.5,211.5 C 140.559,225.998 129.559,242.665 121.5,261.5C 120.833,261.5 120.167,261.5 119.5,261.5C 116.833,260.167 114.167,258.833 111.5,257.5C 120.986,239.87 131.986,223.203 144.5,207.5C 148.013,208.664 151.346,209.998 154.5,211.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6b125",
    d: "M 154.5,211.5 C 157.744,212.463 160.744,213.796 163.5,215.5C 151.617,230.406 141.284,246.406 132.5,263.5C 132.043,264.298 131.376,264.631 130.5,264.5C 127.215,264.072 124.215,263.072 121.5,261.5C 129.559,242.665 140.559,225.998 154.5,211.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.887
    },
    fill: "#d54a23",
    d: "M 155.5,194.5 C 166.834,204.867 176.501,216.534 184.5,229.5C 181.786,226.785 178.786,224.451 175.5,222.5C 174.306,221.728 173.306,220.728 172.5,219.5C 166.104,213.965 158.771,209.965 150.5,207.5C 151.37,202.777 153.036,198.444 155.5,194.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eeb5d4",
    d: "M 367.5,211.5 C 368.391,212.261 369.058,213.261 369.5,214.5C 370.689,215.429 372.022,215.762 373.5,215.5C 373.5,214.5 373.5,213.5 373.5,212.5C 375.715,218.049 377.048,223.882 377.5,230C 376.544,233.394 376.211,236.894 376.5,240.5C 375.778,240.082 375.278,239.416 375,238.5C 374.667,239.167 374.333,239.833 374,240.5C 372.886,247.637 370.553,254.304 367,260.5C 360.916,244.096 361.083,227.763 367.5,211.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7b72d",
    d: "M 163.5,215.5 C 166.648,216.576 169.648,217.909 172.5,219.5C 173.306,220.728 174.306,221.728 175.5,222.5C 162.85,236.172 152.517,251.505 144.5,268.5C 143.167,268.5 141.833,268.5 140.5,268.5C 137.098,267.365 133.765,266.032 130.5,264.5C 131.376,264.631 132.043,264.298 132.5,263.5C 141.284,246.406 151.617,230.406 163.5,215.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.916
    },
    fill: "#b1b2b1",
    d: "M 434.5,222.5 C 438.555,222.176 442.555,222.509 446.5,223.5C 444.955,224.452 443.288,224.785 441.5,224.5C 440.833,244.5 440.167,244.5 439.5,224.5C 437.219,224.923 435.552,224.256 434.5,222.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.697
    },
    fill: "#b1b2b1",
    d: "M 460.5,222.5 C 461.822,222.33 462.989,222.663 464,223.5C 465.932,228.462 467.765,233.462 469.5,238.5C 469,238.833 468.5,239.167 468,239.5C 466.454,237.759 464.454,236.759 462,236.5C 459.546,236.759 457.546,237.759 456,239.5C 455.5,239.167 455,238.833 454.5,238.5C 456.516,233.141 458.516,227.808 460.5,222.5 Z M 461.5,227.5 C 465.561,232.095 464.894,233.928 459.5,233C 460.464,231.275 461.131,229.441 461.5,227.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.705
    },
    fill: "#b1b2b1",
    d: "M 482.5,222.5 C 485.187,222.336 487.854,222.503 490.5,223C 492.303,223.637 493.636,224.803 494.5,226.5C 493.833,226.833 493.167,227.167 492.5,227.5C 486.7,223.057 482.7,224.391 480.5,231.5C 482.61,236.984 486.11,238.318 491,235.5C 491.483,234.552 491.649,233.552 491.5,232.5C 489.396,232.799 487.396,232.466 485.5,231.5C 488.768,230.513 492.102,230.18 495.5,230.5C 493.87,239.662 488.87,242.162 480.5,238C 476.384,232.192 477.05,227.025 482.5,222.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.744
    },
    fill: "#b1b2b1",
    d: "M 504.5,222.5 C 505.5,222.5 506.5,222.5 507.5,222.5C 507.5,227.5 507.5,232.5 507.5,237.5C 509.604,237.201 511.604,237.534 513.5,238.5C 510.572,239.484 507.572,239.817 504.5,239.5C 504.5,233.833 504.5,228.167 504.5,222.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.744
    },
    fill: "#b1b2b1",
    d: "M 522.5,222.5 C 523.5,222.5 524.5,222.5 525.5,222.5C 525.5,228.167 525.5,233.833 525.5,239.5C 524.5,239.5 523.5,239.5 522.5,239.5C 522.5,233.833 522.5,228.167 522.5,222.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.73
    },
    fill: "#b1b2b1",
    d: "M 535.5,222.5 C 536.822,222.33 537.989,222.663 539,223.5C 541.333,227.167 543.667,230.833 546,234.5C 546.499,230.514 546.666,226.514 546.5,222.5C 547.5,222.5 548.5,222.5 549.5,222.5C 549.5,228.167 549.5,233.833 549.5,239.5C 547.856,239.714 546.356,239.38 545,238.5C 543,235.167 541,231.833 539,228.5C 538.501,232.152 538.335,235.818 538.5,239.5C 537.5,239.5 536.5,239.5 535.5,239.5C 535.5,233.833 535.5,228.167 535.5,222.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.771
    },
    fill: "#b1b2b1",
    d: "M 559.5,222.5 C 562.572,222.183 565.572,222.516 568.5,223.5C 566.604,224.466 564.604,224.799 562.5,224.5C 562.5,226.167 562.5,227.833 562.5,229.5C 564.5,229.5 566.5,229.5 568.5,229.5C 568.5,230.5 568.5,231.5 568.5,232.5C 566.5,232.5 564.5,232.5 562.5,232.5C 562.5,234.167 562.5,235.833 562.5,237.5C 564.604,237.201 566.604,237.534 568.5,238.5C 565.572,239.484 562.572,239.817 559.5,239.5C 559.5,233.833 559.5,228.167 559.5,222.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.723
    },
    fill: "#b1b2b1",
    d: "M 596.5,222.5 C 601.538,221.448 605.538,222.948 608.5,227C 605.402,227.271 602.568,226.438 600,224.5C 594.322,226.859 593.156,230.692 596.5,236C 600.255,238.132 603.255,237.299 605.5,233.5C 603.167,232.833 600.833,232.167 598.5,231.5C 601.768,230.513 605.102,230.18 608.5,230.5C 607.725,238.775 603.392,241.608 595.5,239C 589.953,233.032 590.287,227.532 596.5,222.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.701
    },
    fill: "#b1b2b1",
    d: "M 622.5,222.5 C 634.061,222.24 637.394,227.407 632.5,238C 622.114,242.288 617.281,238.788 618,227.5C 619.025,225.313 620.525,223.646 622.5,222.5 Z M 625.5,224.5 C 631.092,225.625 632.926,228.958 631,234.5C 625.744,238.963 622.244,237.797 620.5,231C 620.645,227.497 622.312,225.33 625.5,224.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.771
    },
    fill: "#b1b2b1",
    d: "M 644.5,222.5 C 647.572,222.183 650.572,222.516 653.5,223.5C 651.604,224.466 649.604,224.799 647.5,224.5C 647.5,226.167 647.5,227.833 647.5,229.5C 649.5,229.5 651.5,229.5 653.5,229.5C 653.5,230.5 653.5,231.5 653.5,232.5C 651.5,232.5 649.5,232.5 647.5,232.5C 647.5,234.167 647.5,235.833 647.5,237.5C 649.604,237.201 651.604,237.534 653.5,238.5C 650.572,239.484 647.572,239.817 644.5,239.5C 644.5,233.833 644.5,228.167 644.5,222.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.669
    },
    fill: "#b1b2b1",
    d: "M 665.5,222.5 C 667.857,222.337 670.19,222.503 672.5,223C 674.037,224.11 674.703,225.61 674.5,227.5C 672.302,226.986 670.302,225.986 668.5,224.5C 666.717,225.348 666.217,226.681 667,228.5C 669.071,229.525 671.238,230.358 673.5,231C 676.503,236.165 675.003,239.332 669,240.5C 665.302,240.394 663.136,238.561 662.5,235C 663.167,234.833 663.833,234.667 664.5,234.5C 667.018,238.071 669.685,238.238 672.5,235C 669.989,232.937 667.156,231.437 664,230.5C 663.109,227.502 663.609,224.836 665.5,222.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.725
    },
    fill: "#b1b2b1",
    d: "M 698.5,222.5 C 699.5,222.5 700.5,222.5 701.5,222.5C 701.5,224.833 701.5,227.167 701.5,229.5C 704.167,229.5 706.833,229.5 709.5,229.5C 709.5,227.167 709.5,224.833 709.5,222.5C 710.5,222.5 711.5,222.5 712.5,222.5C 712.5,228.167 712.5,233.833 712.5,239.5C 711.5,239.5 710.5,239.5 709.5,239.5C 709.5,237.167 709.5,234.833 709.5,232.5C 706.833,232.5 704.167,232.5 701.5,232.5C 701.5,234.833 701.5,237.167 701.5,239.5C 700.5,239.5 699.5,239.5 698.5,239.5C 698.5,233.833 698.5,228.167 698.5,222.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.771
    },
    fill: "#b1b2b1",
    d: "M 722.5,222.5 C 725.572,222.183 728.572,222.516 731.5,223.5C 729.604,224.466 727.604,224.799 725.5,224.5C 725.5,226.167 725.5,227.833 725.5,229.5C 727.5,229.5 729.5,229.5 731.5,229.5C 731.5,230.5 731.5,231.5 731.5,232.5C 729.5,232.5 727.5,232.5 725.5,232.5C 725.5,234.167 725.5,235.833 725.5,237.5C 727.604,237.201 729.604,237.534 731.5,238.5C 728.572,239.484 725.572,239.817 722.5,239.5C 722.5,233.833 722.5,228.167 722.5,222.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.719
    },
    fill: "#b1b2b1",
    d: "M 741.5,222.5 C 745.584,222.043 749.417,222.71 753,224.5C 754.075,228.067 753.242,231.067 750.5,233.5C 751.248,235.332 752.248,236.999 753.5,238.5C 752.167,239.833 750.833,239.833 749.5,238.5C 748.913,235.594 747.246,233.928 744.5,233.5C 744.5,235.5 744.5,237.5 744.5,239.5C 743.5,239.5 742.5,239.5 741.5,239.5C 741.5,233.833 741.5,228.167 741.5,222.5 Z M 744.5,224.5 C 746.5,224.833 748.5,225.167 750.5,225.5C 750.938,229.908 748.938,231.575 744.5,230.5C 744.5,228.5 744.5,226.5 744.5,224.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.771
    },
    fill: "#b1b2b1",
    d: "M 763.5,222.5 C 766.572,222.183 769.572,222.516 772.5,223.5C 770.604,224.466 768.604,224.799 766.5,224.5C 766.5,226.167 766.5,227.833 766.5,229.5C 768.5,229.5 770.5,229.5 772.5,229.5C 772.5,230.5 772.5,231.5 772.5,232.5C 770.5,232.5 768.5,232.5 766.5,232.5C 766.5,234.167 766.5,235.833 766.5,237.5C 768.604,237.201 770.604,237.534 772.5,238.5C 769.572,239.484 766.572,239.817 763.5,239.5C 763.5,233.833 763.5,228.167 763.5,222.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.997
    },
    fill: "#f7bb39",
    d: "M 175.5,222.5 C 178.786,224.451 181.786,226.785 184.5,229.5C 185.5,229.833 186.167,230.5 186.5,231.5C 175.21,243.396 165.876,256.73 158.5,271.5C 153.578,271.13 148.911,270.13 144.5,268.5C 152.517,251.505 162.85,236.172 175.5,222.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e98e3b",
    d: "M 58.5,220.5 C 60.8333,222.5 63.1667,224.5 65.5,226.5C 66.8333,228.167 68.1667,229.833 69.5,231.5C 65.8505,233.954 61.8505,235.787 57.5,237C 56.7476,237.671 56.4142,238.504 56.5,239.5C 52.446,235.082 49.1127,230.082 46.5,224.5C 50.8117,223.986 54.8117,222.652 58.5,220.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#f8c045",
    d: "M 186.5,231.5 C 188.939,235.275 190.939,239.275 192.5,243.5C 185.111,252.575 178.444,262.242 172.5,272.5C 172.043,273.298 171.376,273.631 170.5,273.5C 166.519,272.979 162.519,272.646 158.5,272.5C 158.5,272.167 158.5,271.833 158.5,271.5C 165.876,256.73 175.21,243.396 186.5,231.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.985
    },
    fill: "#9f3a8f",
    d: "M 261.5,237.5 C 276.835,260.498 289.835,284.832 300.5,310.5C 299.971,312.583 298.971,314.417 297.5,316C 297.728,316.399 298.062,316.565 298.5,316.5C 296.167,319.5 293.5,322.167 290.5,324.5C 282.343,302.524 272.343,281.524 260.5,261.5C 261.925,253.51 262.258,245.51 261.5,237.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eea24e",
    d: "M 69.5,231.5 C 70.1667,231.833 70.8333,232.167 71.5,232.5C 73.8785,234.878 76.5451,236.878 79.5,238.5C 81.2964,240.9 83.6298,242.567 86.5,243.5C 86.5,243.833 86.5,244.167 86.5,244.5C 79.3887,244.896 73.0554,247.229 67.5,251.5C 64.1667,248.167 60.8333,244.833 57.5,241.5C 57.1667,240.833 56.8333,240.167 56.5,239.5C 56.4142,238.504 56.7476,237.671 57.5,237C 61.8505,235.787 65.8505,233.954 69.5,231.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ae5b",
    d: "M 86.5,244.5 C 89.5498,246.692 92.8832,248.358 96.5,249.5C 96.5,249.833 96.5,250.167 96.5,250.5C 90.4741,253.845 84.4741,257.178 78.5,260.5C 76.3428,258.588 74.0094,256.921 71.5,255.5C 70.5,253.833 69.1667,252.5 67.5,251.5C 73.0554,247.229 79.3887,244.896 86.5,244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.936
    },
    fill: "#e98a24",
    d: "M 57.5,241.5 C 60.8333,244.833 64.1667,248.167 67.5,251.5C 69.1667,252.5 70.5,253.833 71.5,255.5C 71.0198,258.443 70.0198,261.11 68.5,263.5C 63.2056,259.873 58.539,255.54 54.5,250.5C 55.7866,247.594 56.7866,244.594 57.5,241.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e68ebd",
    d: "M 342.5,240.5 C 342.816,254.461 346.816,267.128 354.5,278.5C 352.833,280.833 350.833,282.833 348.5,284.5C 346.549,283.718 345.049,282.384 344,280.5C 340.312,273.464 337.479,266.131 335.5,258.5C 337.854,252.424 340.188,246.424 342.5,240.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.965
    },
    fill: "#f8c453",
    d: "M 192.5,243.5 C 202.216,271.716 192.216,288.05 162.5,292.5C 163.693,289.948 165.027,287.448 166.5,285C 165.906,284.536 165.239,284.369 164.5,284.5C 170.621,282.773 176.288,279.939 181.5,276C 177.831,274.907 174.164,274.074 170.5,273.5C 171.376,273.631 172.043,273.298 172.5,272.5C 178.444,262.242 185.111,252.575 192.5,243.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5c06b",
    d: "M 96.5,250.5 C 98.7128,251.773 101.046,252.773 103.5,253.5C 105.849,255.341 108.515,256.674 111.5,257.5C 114.167,258.833 116.833,260.167 119.5,261.5C 114.466,264.172 109.466,266.839 104.5,269.5C 102.181,269.992 100.181,270.992 98.5,272.5C 94.6733,270.754 91.0066,268.754 87.5,266.5C 84.328,264.748 81.328,262.748 78.5,260.5C 84.4741,257.178 90.4741,253.845 96.5,250.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.982
    },
    fill: "#a73a8f",
    d: "M 260.5,261.5 C 272.343,281.524 282.343,302.524 290.5,324.5C 283.975,330.343 276.641,335.01 268.5,338.5C 262.722,322.943 256.388,307.609 249.5,292.5C 254.58,282.672 258.247,272.339 260.5,261.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.931
    },
    fill: "#ed9726",
    d: "M 71.5,255.5 C 74.0094,256.921 76.3428,258.588 78.5,260.5C 81.328,262.748 84.328,264.748 87.5,266.5C 87.2444,269.598 86.5778,272.598 85.5,275.5C 79.2695,272.225 73.6028,268.225 68.5,263.5C 70.0198,261.11 71.0198,258.443 71.5,255.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8cc74",
    d: "M 119.5,261.5 C 120.167,261.5 120.833,261.5 121.5,261.5C 124.215,263.072 127.215,264.072 130.5,264.5C 133.765,266.032 137.098,267.365 140.5,268.5C 133.755,272.016 126.421,273.683 118.5,273.5C 118.5,272.5 118.5,271.5 118.5,270.5C 115.918,269.436 111.251,269.103 104.5,269.5C 109.466,266.839 114.466,264.172 119.5,261.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e37fb4",
    d: "M 335.5,258.5 C 337.479,266.131 340.312,273.464 344,280.5C 345.049,282.384 346.549,283.718 348.5,284.5C 345.279,288.776 341.279,292.109 336.5,294.5C 332.154,289.148 328.821,283.148 326.5,276.5C 328.167,272.5 329.833,268.5 331.5,264.5C 332.833,262.5 334.167,260.5 335.5,258.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9d17f",
    d: "M 140.5,268.5 C 141.833,268.5 143.167,268.5 144.5,268.5C 148.911,270.13 153.578,271.13 158.5,271.5C 158.5,271.833 158.5,272.167 158.5,272.5C 148.232,274.643 138.065,277.309 128,280.5C 126.97,280.836 126.47,281.503 126.5,282.5C 118.9,280.966 111.566,278.633 104.5,275.5C 102.5,274.5 100.5,273.5 98.5,272.5C 100.181,270.992 102.181,269.992 104.5,269.5C 111.251,269.103 115.918,269.436 118.5,270.5C 118.5,271.5 118.5,272.5 118.5,273.5C 126.421,273.683 133.755,272.016 140.5,268.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.935
    },
    fill: "#f1a326",
    d: "M 87.5,266.5 C 91.0066,268.754 94.6733,270.754 98.5,272.5C 100.5,273.5 102.5,274.5 104.5,275.5C 103.629,278.112 102.963,280.779 102.5,283.5C 96.7126,281.106 91.0459,278.44 85.5,275.5C 86.5778,272.598 87.2444,269.598 87.5,266.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbda92",
    d: "M 158.5,272.5 C 162.519,272.646 166.519,272.979 170.5,273.5C 174.164,274.074 177.831,274.907 181.5,276C 176.288,279.939 170.621,282.773 164.5,284.5C 155.167,285.833 145.833,285.833 136.5,284.5C 133.239,283.622 129.906,282.956 126.5,282.5C 126.47,281.503 126.97,280.836 128,280.5C 138.065,277.309 148.232,274.643 158.5,272.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#df6eab",
    d: "M 326.5,276.5 C 328.821,283.148 332.154,289.148 336.5,294.5C 334.469,296.522 332.135,298.189 329.5,299.5C 327.983,299.489 326.816,298.823 326,297.5C 323.628,294.09 321.795,290.423 320.5,286.5C 320.557,285.391 320.89,284.391 321.5,283.5C 322.921,280.991 324.588,278.657 326.5,276.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.927
    },
    fill: "#f6b52c",
    d: "M 104.5,275.5 C 111.566,278.633 118.9,280.966 126.5,282.5C 129.906,282.956 133.239,283.622 136.5,284.5C 135.833,287.167 135.167,289.833 134.5,292.5C 123.468,290.71 112.801,287.71 102.5,283.5C 102.963,280.779 103.629,278.112 104.5,275.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.932
    },
    fill: "#f8be40",
    d: "M 136.5,284.5 C 145.833,285.833 155.167,285.833 164.5,284.5C 165.239,284.369 165.906,284.536 166.5,285C 165.027,287.448 163.693,289.948 162.5,292.5C 153.177,293.717 143.844,293.717 134.5,292.5C 135.167,289.833 135.833,287.167 136.5,284.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.976
    },
    fill: "#b13c8f",
    d: "M 249.5,292.5 C 256.388,307.609 262.722,322.943 268.5,338.5C 263.919,341.622 258.919,343.956 253.5,345.5C 249.677,332.365 244.677,319.698 238.5,307.5C 241.934,302.284 245.601,297.284 249.5,292.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dc60a2",
    d: "M 320.5,286.5 C 321.795,290.423 323.628,294.09 326,297.5C 326.816,298.823 327.983,299.489 329.5,299.5C 326.024,302.623 322.024,304.957 317.5,306.5C 315.178,304.414 313.178,301.914 311.5,299C 314.363,294.652 317.363,290.485 320.5,286.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.92
    },
    fill: "#df6daa",
    d: "M 119.5,328.5 C 123.674,334.846 127.341,341.512 130.5,348.5C 97.1354,335.305 69.302,314.638 47,286.5C 46.3333,285.833 46.3333,285.167 47,284.5C 69.0103,302.668 93.177,317.335 119.5,328.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.972
    },
    fill: "#b83c8f",
    d: "M 238.5,307.5 C 244.677,319.698 249.677,332.365 253.5,345.5C 250.203,347.601 246.537,348.935 242.5,349.5C 238.613,338.173 233.946,327.173 228.5,316.5C 231.808,313.529 235.141,310.529 238.5,307.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.971
    },
    fill: "#c03d90",
    d: "M 228.5,316.5 C 233.946,327.173 238.613,338.173 242.5,349.5C 234.081,352.44 225.414,354.773 216.5,356.5C 213.165,347.493 209.831,338.493 206.5,329.5C 214.493,326.175 221.826,321.841 228.5,316.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.97
    },
    fill: "#cb3e90",
    d: "M 206.5,329.5 C 209.831,338.493 213.165,347.493 216.5,356.5C 211.187,357.098 205.854,357.431 200.5,357.5C 197.305,349.917 194.305,342.251 191.5,334.5C 196.563,333.035 201.563,331.368 206.5,329.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.936
    },
    fill: "#da579d",
    d: "M 119.5,328.5 C 130.197,331.508 140.864,334.174 151.5,336.5C 155.046,342.925 158.046,349.592 160.5,356.5C 150.32,354.455 140.32,351.789 130.5,348.5C 127.341,341.512 123.674,334.846 119.5,328.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.956
    },
    fill: "#d44392",
    d: "M 191.5,334.5 C 194.305,342.251 197.305,349.917 200.5,357.5C 200.5,357.833 200.5,358.167 200.5,358.5C 192.167,358.5 183.833,358.5 175.5,358.5C 170.68,357.513 165.68,356.847 160.5,356.5C 158.046,349.592 155.046,342.925 151.5,336.5C 164.937,337.956 178.27,337.29 191.5,334.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftware);
export default __webpack_public_path__ + "static/media/software.395d7fd00efce596c7cdb3f13462cac7.svg";
export { ForwardRef as ReactComponent };